/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Balance1Inputs */

const zh_chat_insufficientcredits_balance1 = /** @type {(inputs: Chat_Insufficientcredits_Balance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前余额`)
};

const en_chat_insufficientcredits_balance1 = /** @type {(inputs: Chat_Insufficientcredits_Balance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current balance`)
};

const es_chat_insufficientcredits_balance1 = /** @type {(inputs: Chat_Insufficientcredits_Balance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo actual`)
};

/**
* | output |
* | --- |
* | "Current balance" |
*
* @param {Chat_Insufficientcredits_Balance1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_balance1 = /** @type {((inputs?: Chat_Insufficientcredits_Balance1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Balance1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_balance1(inputs)
	if (locale === "en") return en_chat_insufficientcredits_balance1(inputs)
	return es_chat_insufficientcredits_balance1(inputs)
});
export { chat_insufficientcredits_balance1 as "chat_insufficientCredits_balance" }